import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FilterSelect from '../../components/FilterSelect';
import * as catalogueActions from '../../actions/catalogue';
import {
    catalogueStateKey,
    isCommonFilterDisabled
} from '../../helpers/catalogueUtils';

class PedigreeFilters extends PureComponent {
    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }
    render() {
        const {
            refinement: {
                sireName,
                damName,
                sireOfDamName,
            },

            data: {
                sireNameOptions,
                damNameOptions,
                sireOfDamNameOptions,
            },

            // Sire
            loadSireNameOptions,
            applyCatalogueSireNameFilter,

            // Dam
            loadDamNameOptions,
            applyCatalogueDamNameFilter,

            // Dam's Sire
            loadSireOfDamNameOptions,
            applyCatalogueSireOfDamNameFilter,
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Sire</span>
                    <FilterSelect
                        title="Sire"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={sireName}
                        options={sireNameOptions}
                        onPopoverDidOpen={loadSireNameOptions}
                        onChange={applyCatalogueSireNameFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Dam</span>
                    <FilterSelect
                        title="Dam"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={damName}
                        options={damNameOptions}
                        onPopoverDidOpen={loadDamNameOptions}
                        onChange={applyCatalogueDamNameFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Dam's Sire</span>
                    <FilterSelect
                        title="Dam's Sire"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={sireOfDamName}
                        options={sireOfDamNameOptions}
                        onPopoverDidOpen={loadSireOfDamNameOptions}
                        onChange={applyCatalogueSireOfDamNameFilter}
                    />
                </div>
            </div>
        );
    }
}

PedigreeFilters.propTypes = {
    refinement: PropTypes.shape({
        sireName: PropTypes.string,
        damName: PropTypes.string,
        sireOfDamName: PropTypes.string,
    }).isRequired,

    data: PropTypes.shape({
        sireNameOptions: PropTypes.array.isRequired,
        damNameOptions: PropTypes.array.isRequired,
        sireOfDamNameOptions: PropTypes.array.isRequired,
    }),

    // Sire
    loadSireNameOptions: PropTypes.func.isRequired,
    applyCatalogueSireNameFilter: PropTypes.func.isRequired,

    // Dam
    loadDamNameOptions: PropTypes.func.isRequired,
    applyCatalogueDamNameFilter: PropTypes.func.isRequired,

    // Dam's Sire
    loadSireOfDamNameOptions: PropTypes.func.isRequired,
    applyCatalogueSireOfDamNameFilter: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    const { refinement, data } = state[catalogueStateKey];
    return { refinement, data };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(catalogueActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PedigreeFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/PedigreeFilters.js